export const deleteQuestionApiUrls = {
	deleteQuestion: 'questions/:questionId',
};
